<template>
  <el-dialog width="420px" title="" class="dialogClass" :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="passwordVisible">
    <div class="details">
      <div class="dialogTilte">修改密码</div>
      <div class="mb-16">
        <el-steps :active="activeStep" align-center>
          <el-step title="安全认证" description=""></el-step>
          <el-step title="修改密码" description=""></el-step>
          <el-step title="完成" description=""></el-step>
        </el-steps>
      </div>
      <el-form    ref="currencyForm"   v-loading="loading"    label-position="right"   label-width="110px"  :model="currencyForm"  :rules="currencyFormRules">
        <template v-if="activeStep == 1">
          <el-form-item prop="account" label="账号">
            <el-input type="text" v-model="currencyForm.account" disabled auto-complete="new-password" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item prop="code" label="验证码">
            <el-input maxlength="6" placeholder="请输入验证码" v-model="currencyForm.code"  auto-complete="new-password">
              <el-button :disabled="getCodeBtnDisabled"  @click="handleClickGetEmailCode('forget')"
                         slot="suffix"
                         type="text">
                {{getCodeText}}
              </el-button>
            </el-input>
          </el-form-item>
        </template>

        <template v-if="activeStep == 2">
          <el-form-item prop="password" label="密码">
            <el-input  type="password" v-model="currencyForm.password"  placeholder="请输入密码" auto-complete="new-password"></el-input>
          </el-form-item>
          <el-form-item prop="repassword" label="确认密码">
            <el-input   type="password" v-model="currencyForm.repassword"   placeholder="请再次确认密码" auto-complete="new-password"></el-input>
          </el-form-item>
        </template>

        <template v-if="activeStep == 3">
          <div class="tips">密码修改成功，将在{{time}}s后退出登录</div>
        </template>


      </el-form>
    </div>
    <div slot="footer">
      <el-button  v-if="activeStep == 1" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button type="primary" v-if="activeStep == 1" :disabled="BtnDisabled" @click="handleClickNext">下一步</el-button>
      <el-button type="primary" v-if="activeStep == 2" :disabled="BtnDisabled" @click="handleClickPrev">上一步</el-button>
      <el-button type="primary" v-if="activeStep == 2" :disabled="BtnDisabled" @click="handleClickConfirm">确认修改</el-button>
      <el-button type="primary" v-if="activeStep == 3" :disabled="BtnDisabled" @click="handleClickLogout">立即登出</el-button>
    </div>
  </el-dialog>
</template>
<script>

import { sendMailCode,resetPassword } from '@/api/api'
import {mapState} from "vuex";
import {sendPhoneCode} from "../../../api/api";
export default {
  name: 'change_password',
  props: {
    passwordVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {

    return {
      loading:false,
      BtnDisabled: false,
      activeStep:1,
      currencyForm:{
        account: '',
        code:'',
        password: '',
        repassword: '',
      },
      currencyFormRules:{

        code:[{ required: true, message: '请输入验证码', trigger: 'blur'}],
        password:[{ required: true, trigger: 'blur',validator: (rule, value, callback) => {
            if (value == '') {
              callback(new Error('请输入密码'))
            } if(value.length<6 || value.length>18){
              callback(new Error('密码长度需在6-18位'))
            }else {
              callback()
            }
          },}],
        repassword:[{ required: true, trigger: 'blur', validator: (rule, value, callback) => {
            if (this.currencyForm.password != this.currencyForm.repassword) {
              callback(new Error('密码不一致'))
            } if(value == ''){
              callback(new Error('请再次确认密码'))
            }else {
              callback()
            }
          },}],
      },
      getCodeTime: 60,
      getCodeBtnDisabled: false,
      time:5

    }
  },

  created() {

  },
  computed: {
    ...mapState(['webUserInfo']),
    getCodeText() {
      if (this.getCodeBtnDisabled) {
        return `${this.getCodeTime}秒后重新发送`;
      } else {
        return '获取验证码';
      }
    },
  },
  mounted() {
    this.currencyForm.account = this.webUserInfo.email ? this.webUserInfo.email :this.webUserInfo.phone
  },
  methods: {
    // 获取验证码
    handleClickGetEmailCode(sendType){
        let account = this.currencyForm.account
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const phonePattern = /^1[3456789]\d{9}$/;
        if(emailPattern.test(account)){
          sendMailCode({
            email: account,
            type : sendType
          }).then(res => {
            if (res.code === 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: 'success',
                duration: 1500,
                onClose: () => { }
              });
              this.getCodeBtnDisabled = true;
              const timer = setInterval(() => {
                if (this.getCodeTime > 0) {
                  this.getCodeTime--;
                } else {
                  this.getCodeBtnDisabled = false;
                  clearInterval(timer);
                  this.getCodeTime = 60;
                }
              }, 1000);
            }
          })
        }else{
          sendPhoneCode({
            phone: account,
            type : sendType
          }).then(res => {
            if (res.code === 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: 'success',
                duration: 1500,
                onClose: () => { }
              });
              this.getCodeBtnDisabled = true;
              const timer = setInterval(() => {
                if (this.getCodeTime > 0) {
                  this.getCodeTime--;
                } else {
                  this.getCodeBtnDisabled = false;
                  clearInterval(timer);
                  this.getCodeTime = 60;
                }
              }, 1000);
            }
          })
        }


    },
    // 下一步
    handleClickNext(){
      this.$refs.currencyForm.validate(valid => {
        if (valid) {
          this.activeStep = 2
        }
     })
    },
    // 上一步
    handleClickPrev(){
      this.activeStep = 1
    },
    // 登出
    handleClickLogout(){
      this.$store.dispatch('clearWebUserInfo')
      this.$router.replace({name:'login'});
    },
    handleClickConfirm(){
      this.$refs.currencyForm.validate(valid => {
        if (valid) {
          resetPassword({
            account:this.currencyForm.account,
            code:this.currencyForm.code,
            password: this.currencyForm.password,
            repassword: this.currencyForm.repassword,
          }).then(res => {
            if (res.code === 200) {
              let {data} = res
              this.$message({
                showClose: true,
                message: res.message,
                type: 'success',
                duration: 1500,
                onClose: () => { }
              });
              this.activeStep = 3
              setInterval(()=>{
                this.time--
                if(this.time == 0){
                  this.$store.dispatch('clearWebUserInfo')
                  this.$router.replace({name:'login'});
                }
              },1000)
            }
          })
        }
      })
    },


    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:passwordVisible', false)
      if( this.activeStep == 3){
        this.$store.dispatch('clearWebUserInfo')
        this.$router.replace({name:'login'});
      }
    },


  },

}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.mt-15{
  margin-top: 15px;
}
.el-select{
  display: block;
}
.tips{
  line-height: 84px;
  margin-bottom: 18px;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
}

</style>
